export const environment = {
  production: false,
  hostDev: 'dikar.aitanasolutions.com',
  API_URL: '/api',
  apiKey: 'f8449092-99ec-48cb-ab50-d4a1b7ff329a',
  tpv_url: 'https://sis-t.redsys.es:25443/sis/realizarPago',
  tpv_pisp_url:
    'https://w5.grupobbva.com/ETPP/etpp_mult_web_frontcertification_02/commerce/certificate',
  googleAnalyticsId: 'G-RES3S2CJET',
  almacen: 398,
  fk_entity: 82,
  clientSecret:
    'MzUzYjMwMmM0NDU3NGY1NjUwNDU2ODdlNTM0ZTdkNmE6Mjg2OTI0Njk3ZTYxNWE2NzJhNjQ2YTQ5MzU0NTY0NmM=',
  captchaSecret: '6LeZzwMkAAAAAG2FYcGudQnDipAJjBBwuSCms4Ff',
};
